import user_api from "../api/admin/admin_user";
import orgadmin_user_api from "../api/orgadmin/orgadmin_user";
import {useEffect, useState} from "react";
import arrow from "../assets/arrow_back.png";
import roles from "../models/Roles";

const OrganisationAddMembers = (props) => {
    const hide = props.hide;
    const role_id = props.role;
    const team_id = props.team;
    const profile = props.profile;
    const [users, setUsers] = useState();

    const handleCancelClick = () => {
        hide();
    }

    const handleSendClick = () => {
        if (!profile) return;
        for(let i=0;i<users.length;i++){
            if (users[i].email != "" && users[i].email != "{sent}"){
                let adjustedRole = role_id;
                if (profile.role_id === roles.ROLE_ADMIN && team_id === 1)
                    adjustedRole = roles.ROLE_ADMIN;

                let body = {
                    "email": users[i].email,
                    "role": adjustedRole,
                    "team": team_id
                }
                let response = null;
                if (profile.role_id === roles.ROLE_ADMIN){
                    response = user_api.inviteAdminUser(body);
                }
                if (profile.role_id === roles.ROLE_ORGANISATION_ADMIN){
                    response = orgadmin_user_api.inviteAdminUser(body);
                }

                response.then(
                    response => {
                        let array = [...users]
                        array[i].email = "{sent}"
                        setUsers(array);
                    }
                )
            }
        }
    }

    const updateEmail = (ev) => {
        if (!ev.target) return;
        if (!users) return;
        const index = parseInt(ev.target.id);

        let array = [...users];
        array[index].email = ev.target.value;
        setUsers(array);
    }

    const handleBackClick = () => {
        hide();
    }

    useEffect(() => {
        let array = [];
        for(let i=0;i<4;i++){
            let user = {}
            user.email = "";
            array.push(user);
        }
        setUsers(array);
    }, [])

    return (
        <>
            <div className="admin-newuser-grid-container">
                <div className="admin-newuser-header link">
                    <img className="link" src={arrow} alt="arrow icon" onClick={handleBackClick}/>
                    Back
                </div>
                <div className="admin-newuser-grid-heading">
                    Team member
                </div>
                <div className="admin-newuser-grid-content">
                    {users && users.map((user, idx) => {
                        return (
                            <>
                                <input type="email" value={user.email} placeholder="Email address" id={idx}
                                       onChange={(ev) => updateEmail(ev)}/>
                            </>
                        )
                    })
                    }
                </div>
                <div className="admin-newuser-buttons">
                    <div className="admin-newuser-invite-button link" onClick={handleSendClick}>Send invites</div>
                    <div className="admin-newuser-cancel-button link" onClick={handleCancelClick}>Cancel</div>
                </div>
            </div>
        </>
    )
}

export default OrganisationAddMembers